/**
 * The default ARIA label for the WeekNumber element.
 */
export var labelMonthDropdown = function () {
    return 'Month: ';
};
//# sourceMappingURL=labelMonthDropdown.js.map